// - Return `null` instead of `NaN` on failure.
// - Doesn't parse things like `42foo` as `42` (vs using `Number.parseFloat()`)
// - Doesn't parse whitespace-only strings as `0` (vs using `Number()`)
// - Doesn't parse "NaN" into `NaN` or "Infinity" into `Infinity` (vs using `Number()`)
// or `Number.parseFloat()`)
// - In short, only parses token sequences that are *exactly* valid JS numbers.
export function safeNumberParse(input: string): number | null {
	if (input == null || input.trim() === '') return null;
	const parsed = Number(input);

	if (!Number.isFinite(parsed)) return null;

	return parsed;
}
